import cn from 'classnames'
import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC, useMemo } from 'react'

import { useGetFormDataField } from 'cng-common/features/form'
import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'

import { PARTNER_BASIC_INFO_FORM_KEY, partnerBasicInfoFields } from '../../../../../configs'
import { TRANSLATION_KEYS } from '../../../../../translations'
import { CompactFormRichTextEditor } from '../../../../compactFormRichTextEditor/CompactFormRichTextEditor'

import styles from './ExecutiveSummaryEditMode.module.scss'

interface IExecutiveSummaryEditModeProps {
  executiveSummary: Nullable<string>
}

export const ExecutiveSummaryEditMode: FC<IExecutiveSummaryEditModeProps> = ({
  executiveSummary,
}) => {
  const [formValue] = useGetFormDataField<string>(
    PARTNER_BASIC_INFO_FORM_KEY,
    partnerBasicInfoFields.summary
  )
  const showCompletenessWarning = useMemo(() => !formValue, [formValue])

  return (
    <div className={styles.root}>
      <Tooltip
        disabled={!showCompletenessWarning}
        tipContent={() => <Translation text={TRANSLATION_KEYS.valueRequiredForCompleteness} />}
      >
        <CompactFormRichTextEditor
          defaultValue={executiveSummary || ''}
          field={partnerBasicInfoFields.summary}
          formKey={PARTNER_BASIC_INFO_FORM_KEY}
          className={cn({
            [styles.warning]: showCompletenessWarning,
          })}
        />
      </Tooltip>
    </div>
  )
}
